var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-generator-logo"},[_c('img',{directives:[{name:"image-error",rawName:"v-image-error"}],attrs:{"src":_vm.appLogoImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }